module.exports = __webpack_public_path__ + "img/icon_sort_desc.6978c465.svg";